import React from "react";
import PropTypes from "prop-types";
import {
  StyledEvidenceSynopsisDiv,
  StyledEvidenceSynopsisType,
  StyledEvidenceSynopsisContent,
} from "./_styled";

const ContentEvidenceSynopsis = ({ content, title }) => {
  return (
    <StyledEvidenceSynopsisDiv data-testid="evidence-synopsis-div">
      <StyledEvidenceSynopsisType
        element="p"
        color="white"
        fontSize="md"
        textTransform="uppercase"
        data-testid="evidence-synopsis-type"
      >
        {title}
      </StyledEvidenceSynopsisType>
      <StyledEvidenceSynopsisContent>{content}</StyledEvidenceSynopsisContent>
    </StyledEvidenceSynopsisDiv>
  );
};

ContentEvidenceSynopsis.propTypes = {
  content: PropTypes.node,
  text: PropTypes.string,
  title: PropTypes.string,
};

ContentEvidenceSynopsis.defaultProps = {
  content: "",
  title: "Evidence Synopsis",
};

ContentEvidenceSynopsis.displayName = "ContentEvidenceSynopsis";

export default ContentEvidenceSynopsis;
